import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import checkCircleIcon, { checkCircleIconSuccess } from '../../assets/icons/check-circle';
import exclamationCircleIcon, { exclamationCircleIconError, } from '../../assets/icons/exclamation-circle';
import '../icon';
import '../typography/tg-body-two';
const VARIANT = ['info', 'success', 'error'];
const DEFAULT_VARIANT = 'info';
const VARIANT_TO_LIT_ICON_MAP = {
    info: null,
    success: checkCircleIcon,
    error: exclamationCircleIcon,
};
const VARIANT_TO_ICON_MAP = {
    info: null,
    success: checkCircleIconSuccess,
    error: exclamationCircleIconError,
};
const VARIANT_TO_COLOR_MAP = {
    info: undefined,
    success: '#91e085',
    error: '#fd6868',
};
/**
 * @dependency amityeko-icon
 * @dependency amityeko-tg-body-two
 *
 * @method show - Call to show the toast
 */
export default class AmityekoToast extends LitElement {
    constructor() {
        super(...arguments);
        this.variant = DEFAULT_VARIANT;
        this.duration = 3000;
        // TODO: BUG - Just discovered that this does not work properly. First toast is empty,
        // next show message from previous
        this.isRepeatToast = false;
    }
    firstUpdated() {
        this.alertElem = this.renderRoot.querySelector('sl-alert');
    }
    show() {
        const validatedVariant = this._getValidatedVariant();
        const iconSvg = VARIANT_TO_ICON_MAP[validatedVariant];
        if (this.isRepeatToast) {
            const newAlert = Object.assign(document.createElement('sl-alert'), {
                variant: validatedVariant,
                duration: this.duration,
                innerHTML: `
        ${iconSvg
                    ? `<amityeko-icon class=${'amityeko-icon-' + validatedVariant} slot="icon">${iconSvg}</amityeko-icon>`
                    : ''}
        ${this.message ? `<amityeko-tg-body-two>${this.message}</amityeko-tg-body-two>` : ''}`,
            });
            newAlert.classList.add('amityeko-alert');
            newAlert.classList.add('amityeko-' + validatedVariant);
            document.body.append(newAlert);
            return newAlert.toast();
        }
        else {
            this.alertElem.toast();
        }
    }
    _getValidatedVariant() {
        return VARIANT.includes(this.variant) ? this.variant : DEFAULT_VARIANT;
    }
    render() {
        const validatedVariant = this._getValidatedVariant();
        const iconSvg = VARIANT_TO_LIT_ICON_MAP[validatedVariant];
        const iconColor = VARIANT_TO_COLOR_MAP[validatedVariant];
        return html `
      <sl-alert
        variant="neutral"
        duration=${this.duration}
        class="amityeko-alert ${classMap({
            'amityeko-info': validatedVariant === 'info',
            'amityeko-success': validatedVariant === 'success',
            'amityeko-error': validatedVariant === 'error',
        })}"
      >
        ${iconSvg
            ? html `
              <amityeko-icon .iconSize=${'16px'} .color=${iconColor} slot="icon">
                ${iconSvg}
              </amityeko-icon>
            `
            : null}
        ${this.message ? html `<amityeko-tg-body-two>${this.message}</amityeko-tg-body-two>` : null}
      </sl-alert>
    `;
    }
}
__decorate([
    state()
], AmityekoToast.prototype, "alertElem", void 0);
__decorate([
    property()
], AmityekoToast.prototype, "variant", void 0);
__decorate([
    property()
], AmityekoToast.prototype, "message", void 0);
__decorate([
    property({ type: Number })
], AmityekoToast.prototype, "duration", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoToast.prototype, "isRepeatToast", void 0);
if (!customElements.get('amityeko-toast')) {
    customElements.define('amityeko-toast', AmityekoToast);
}
//# sourceMappingURL=index.js.map